import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, concatMap, filter } from 'rxjs/operators';
import { Action } from 'redux';
import AppState from '../../state';
import { UPDATE_TRACK_FIELD } from '../actions';
import { UpdateTrackField } from '../action-creators';

/**
 *
 * This effect updates Tracks' language and metadata language based on presets
 *
 */

export const updateTrackLanguagePresetsEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, UpdateTrackField<'type'>>(UPDATE_TRACK_FIELD),
    withLatestFrom(state$),
    filter(([action, state]) => {
      return action.field === 'type' &&
             action.value === 'song' &&
             !!state.presets.presets?.language && (
               !state.tracks.tracks[action.trackId]?.language ||
               !state.tracks.tracks[action.trackId]?.metadataLanguage
             )
    }),
    concatMap(([action, state]) => {
      const language = state.presets.presets!.language;

      const actions: Action[] = [];

      if (!state.tracks.tracks[action.trackId]?.language) {
        actions.push(new UpdateTrackField<'language'>(action.trackId, 'language', language));
      }

      if (!state.tracks.tracks[action.trackId]?.metadataLanguage) {
        actions.push(new UpdateTrackField<'metadataLanguage'>(action.trackId, 'metadataLanguage', language));
      }

      return actions;
    })
  );